<template>
  <div
    class="sj-loading"
    v-show="visible"
    :style="{
      zIndex
    }"
  >
    <component :is="`theme${theme}`"></component>
    <p v-if="text" class="sj-loading-text">{{ text }}</p>
  </div>
</template>

<script>
/**
 * loading组件为含有样式的遮罩div
 * 通过指令方式使用，详见index.js
 */
import PopupManager from "../../../utils/popup/popupManager.js";
import theme1 from "./themes/theme1";
import theme2 from "./themes/theme2";
import theme3 from "./themes/theme3";

export default {
  name: "SjLoading",
  components: {
    theme1,
    theme2,
    theme3
  },
  data() {
    return {
      text: "Loading...",
      visible: false,
      zIndex: 2000,
      theme: "1"
    };
  },
  methods: {
    setText(text) {
      this.text = text;
    },
    setTheme(theme) {
      this.theme = theme;
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.zIndex = PopupManager.nextZIndex();
        }
      }
    }
  }
};
</script>

<style lang="less">
.sj-loading-parent--relative {
  position: relative;
  // overflow: visible !important;
}
</style>

<style lang="less" scoped>
.sj-loading {
  position: absolute;
  background-color: fade(@color-antibg, 90%);
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  transition: opacity 0.3s;
  .sj-loading-text {
    position: absolute;
    top: calc(50% + 30px);
    width: 100%;
    text-align: center;
    .text("body", "available");
  }
}
</style>
